import $ from 'jquery';
import onDocumentReady from '../utilities/onDocumentReady';

function imgToSvg() {
    const imagesCash = [];
    $('img[src$=".svg"]').each(function () {
        const $img = $(this);
        const imgId = $img.attr('id');
        const imgClass = $img.attr('class');
        const imgUrl = $img.attr('src');

        if (!imagesCash[imgUrl]) {
            $.get(imgUrl, (data) => {
                // Get the SVG tag, ignore the rest
                let $svg = $(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgId !== 'undefined') {
                    $svg = $svg.attr('id', imgId);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', `${imgClass} replaced-svg`);
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);
                imagesCash[imgUrl] = $svg;
            }, 'xml');
        } else {
            $img.replaceWith(imagesCash[imgUrl]);
        }
    });
}

onDocumentReady(() => {
    // imgToSvg();
});
